import React from 'react'
import "./ComingSoon.css"

export const ComingSoon = () => {
    return (
        <div style={{ position: "relative" }}>
            <div className="coming-soon">
                <div>
                    <p className="color-coming-soon">
                        <p className="come">Coming Soon</p>

                    </p>
                </div>
                <div className='fire-abs'>
                </div>
            </div>
        </div>
    )
}
